import React, { useEffect, useState } from 'react'
import {
    Button,
    Image,
    ScrollView,
    Text,
    TextInput,
    TouchableOpacity,
    View,
    StyleSheet,
} from 'react-native'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import { Feather } from '@expo/vector-icons'
import theme from '../../../../theme'
import { placeholderGeneral } from '../../customUtils/Constants'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import {
    ImageWithZoom,
    ImageWithZoomStores,
} from '../../customUtils/Components/ImageWIthZoom'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import styles from './InputPriceNaStyles'
import useImageLoader from '../../../hooks/useImageLoader'
import { PATH_ASSETS } from '../../../utils/Constants'
import { Loader } from '../../customUtils/Components/Loader'
import { useValidationAlerts } from '../FieldItems/useValidationAlerts'

interface InputPriceNaI {
    item: FormContentsModel
    form_id?: string
    schedule_id?: string
    store_id?: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    name_form?: string
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
}

export const InputPriceNa = React.memo(
    ({
        item,
        name_form,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
        keyboardHiddenState,
        onFocus,
        activeInputId,
    }: InputPriceNaI) => {
        const [price, setPrice] = useState('')
        const [lastSavedPrice, setLastSavedPrice] = useState('')
        const [na, setNa] = useState(false)
        const { openBottomSheet } = useBottomSheet()
        const [buttomAdd, setbuttomAdd] = useState(false)
        const { checkAlerts } = useValidationAlerts()
        const { image, loading } = useImageLoader(item.media, PATH_ASSETS)
        const [preview, setPreview] = useState(image)

        const fontSize = price.length <= 4 ? 14 : price.length <= 7 ? 13 : 12

        useEffect(() => {
            if (item?.old_response) {
                if (
                    item?.old_response.option_selected_text &&
                    item?.old_response.option_selected_text.length > 0
                ) {
                    //si selecciono na
                    setNa(true)
                    setbuttomAdd(false)
                }
                if (
                    item?.old_response.question_input &&
                    item?.old_response.question_input != ''
                ) {
                    setPrice(item?.old_response.question_input)
                    setLastSavedPrice(item?.old_response.question_input)
                } else {
                    setPrice('')
                    setLastSavedPrice('')
                }

                if (item.old_response.question_input !== '') {
                    setbuttomAdd(true)
                    setNa(false)
                }
            }
        }, [item])
        useEffect(() => {
            setPreview(image)
        }, [image])

        const updatePrice = async (newPrice: string) => {
            // Evitar guardar si el valor no cambió
            if (newPrice === lastSavedPrice) {
                return
            }

            const action = await checkAlerts(item, newPrice, {
                label: item.title,
                media: item.media || undefined,
            })
            if (action === 'reset') {
                setPrice('')
                return
            }
            setPrice(newPrice)
            setLastSavedPrice(newPrice)
            handleConfirmar(newPrice)
        }

        const isModalClosable = true
        const isModalClosableTouch = true
        const isModalClosableSlice = false
        const keyboardShouldPersistTaps = true

        const openSheet = (showImage) => {
            openBottomSheet(
                <InputPriceSheet
                    item={item}
                    prevPrice={price}
                    prevNa={na}
                    updatePrice={updatePrice}
                    updateNa={(na) => setNa(na)}
                    name_form={name_form}
                    form_id={form_id}
                    schedule_id={schedule_id}
                    store_id={store_id}
                    checkComplete={checkComplete}
                    handleOnPressNa={handleOnPressNa}
                    showImage={showImage}
                />,
                undefined,
                keyboardShouldPersistTaps,
                isModalClosable,
                isModalClosableSlice,
                isModalClosableTouch,
            )
        }

        // aprento na por fuera
        const handleOnPressNa = async () => {
            // console.log('🟡 [InputPriceNa] handleOnPressNa START', {
            //     questionId: item._id,
            //     questionTitle: item.title?.substring(0, 50),
            //     currentPrice: price,
            //     currentNa: na,
            //     schedule_id,
            //     form_id,
            //     store_id,
            //     timestamp: new Date().toISOString()
            // })

            const answer: ModelAnswerFromProps = {
                _id: item._id,
                option_selected_text: ['na'],
                option_selected_id: ['3'],
                question_id: item._id,
                media: '',
                question_text: item.title,
                score: '0',
                status: 1,
                date_finish: new Date().toString(),
                date_init: new Date().toString(),
                question_input: '',
                field_media: '',
                field_text: '',
                questionScore: item.questionScore,
                type: item.input_type.type,
                ponderar: item.questionScore && item.questionScore > 0, //[7, 8, 14, 18].includes(item.input_type.type),

                question: item.title,
                questionOptionSelected: ['3'],
                questionOptionSelectedText: ['na'],
                questionType: {
                    title: item.input_type.title,
                    type: item.input_type.type,
                    id: item.input_type._id,
                },
                questionPrice: '',
                description: '',
                tag: '',
                questionImage: '',
                questionInput: '',
            }

            setNa(true)
            setbuttomAdd(false)

            console.log('📝 [InputPriceNa] handleOnPressNa - Answer created', {
                questionId: item._id,
                answerData: answer,
                timestamp: new Date().toISOString(),
            })

            try {
                // console.log('💾 [InputPriceNa] handleOnPressNa - Calling updateFormAnswerSchedule...', {
                //     schedule_id,
                //     form_id,
                //     store_id
                // })

                await updateFormAnswerSchedule({
                    newAnswer: answer,
                    schedule_id,
                    form_id,
                    store_id,
                })

                // console.log('✅ [InputPriceNa] handleOnPressNa - updateFormAnswerSchedule completed')

                await checkComplete(answer)

                console.log(
                    '✅ [InputPriceNa] handleOnPressNa - checkComplete completed',
                )
            } catch (error) {
                console.error('❌ [InputPriceNa] handleOnPressNa ERROR:', {
                    questionId: item._id,
                    error: error.message,
                    stack: error.stack,
                    timestamp: new Date().toISOString(),
                })
                throw error
            }
        }

        const handleConfirmar = async (priceValue?: string) => {
            const startTime = Date.now()
            const currentPrice = priceValue !== undefined ? priceValue : price

            let answerScore = '0'
            let canSum = false
            let answerAsNumber = parseFloat(currentPrice)
            if (!isNaN(answerAsNumber) && answerAsNumber > 0) canSum = true
            if (item.score != null && canSum === true && currentPrice != '')
                answerScore = item.score.toString()

            const answer: ModelAnswerFromProps = {
                _id: item._id,
                option_selected_text: [],
                option_selected_id: [],
                question_id: item._id,
                media: '',
                question_text: item.title,
                score: answerScore,
                status: 1,
                date_finish: new Date().toString(),
                date_init: new Date().toString(),
                question_input: currentPrice,
                field_media: '',
                field_text: '',
                questionScore: item.questionScore,
                type: item.input_type.type,
                ponderar: item.score && item.score > 0, //[7, 8, 14, 18].includes(item.input_type.type),

                question: item.title,
                questionOptionSelected: [],
                questionOptionSelectedText: [],
                questionType: {
                    title: item.input_type.title,
                    type: item.input_type.type,
                    id: item.input_type._id,
                },
                questionPrice: currentPrice,
                description: '',
                tag: '',
                questionImage: '',
                questionInput: currentPrice,
            }
            setNa(false)

            try {
                const updateResult = await updateFormAnswerSchedule({
                    newAnswer: answer,
                    schedule_id,
                    form_id,
                    store_id,
                })

                const elapsed = Date.now() - startTime

                checkComplete(answer)
            } catch (error) {
                console.error('❌ [InputPriceNa] handleConfirmar ERROR:', {
                    questionId: item._id,
                    questionTitle: item.title,
                    price,
                    schedule_id,
                    form_id,
                    store_id,
                    error: error.message,
                    stack: error.stack,
                    elapsedMs: Date.now() - startTime,
                    timestamp: new Date().toISOString(),
                })
                throw error
            }
        }

        const openBigImage = () => {
            if (image) {
                openBottomSheet(
                    <ImageWithZoom uri={image} contentSeen={() => {}} path={''} />,
                    undefined,
                    undefined,
                    true,
                    true,
                    true,
                )
            }
        }

        return (
            <View style={styles.container}>
                <View style={styles.flexDirectionRow}>
                    {item.media && (
                        <TouchableOpacity onPress={() => openBigImage()}>
                            {loading ? (
                                <Loader />
                            ) : (
                                <Image
                                    style={styles.image}
                                    source={{ uri: preview }}
                                    onError={(e) => {
                                        setPreview(placeholderGeneral)
                                    }}
                                />
                            )}
                        </TouchableOpacity>
                    )}

                    <View style={styles.containerData}>
                        {item.title && (
                            <Text style={styles.title}>{item.title}</Text>
                        )}
                        {item.description && (
                            <Text style={styles.description}>
                                {item.description}
                            </Text>
                        )}
                    </View>

                    <View style={styles.containerInput}>
                        <View style={styles.containerButton}>
                            {/* buttomAdd */}
                            {/* <TouchableOpacity
                            onPress={() => openSheet(false)}
                            style={buttomAdd ? styles.containerButtonPick : styles.containerMiniButton}
                        >
                            <Text style={buttomAdd ? styles.textButtonPick : styles.textMiniButton}>Agregar</Text>
                            <Feather name='edit-2' size={10} color={buttomAdd ? 'white' : theme.colors.colorPrimary} style={styles.marginLeft} />
                        </TouchableOpacity> */}
                            <TextInput
                                style={[styles.input, { fontSize }]}
                                autoFocus={false}
                                placeholder='----'
                                placeholderTextColor={theme.colors.inputPlaceholder}
                                value={price}
                                onChangeText={(text) => {
                                    setPrice(text)
                                }}
                                keyboardType='number-pad'
                                inputMode='decimal'
                                onEndEditing={(e) => {
                                    const currentValue = e.nativeEvent.text
                                    updatePrice(currentValue)
                                }}
                                onFocus={() => {
                                    onFocus(item._id)
                                }}
                            />
                        </View>

                        <View>
                            <TouchableOpacity
                                onPress={() => handleOnPressNa()}
                                style={[
                                    styles.containerMiniButtonBisSelected,
                                    na && {
                                        borderColor: theme.colors.darkGray,
                                        backgroundColor: theme.colors.darkGray,
                                    },
                                ]}
                            >
                                <Text
                                    style={
                                        na
                                            ? styles.textButtonNASelectedBis
                                            : styles.textButtonNAUnselectedBis
                                    }
                                >
                                    No aplica
                                </Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
                {/* <View style={styles.dividerHorizontalLine}></View> */}
            </View>
        )
    },
)

interface InputPriceSheetI {
    item: FormContentsModel
    prevPrice: string
    prevNa: boolean
    updatePrice: (newPrice: string) => void
    updateNa: (na: boolean) => void
    name_form: string
    form_id?: string
    schedule_id?: string
    store_id?: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    handleOnPressNa?: () => void
    showImage: boolean
}

export const InputPriceSheet = ({
    item,
    prevPrice,
    prevNa,
    updatePrice,
    updateNa,
    name_form,
    checkComplete,
    form_id,
    schedule_id,
    store_id,
    handleOnPressNa,
    showImage,
}: InputPriceSheetI) => {
    const [na, setNa] = useState(prevNa)
    const [price, setPrice] = useState(prevPrice)
    const { closeBottomSheet } = useBottomSheet()

    const { languageFile } = getLanguage()

    useEffect(() => {
        if (item?.old_response) {
            if (item?.old_response.question_input !== '') {
                newPrice(item?.old_response.question_input)
            }
        }
    }, [item?.old_response])

    const newPrice = (price: string) => {
        updatePrice(price)
        setPrice(price)
    }

    const newNa = (value: boolean) => {
        updateNa(value)
        setNa(value)
    }

    useEffect(() => {
        setNa(prevNa)
    }, [prevNa])

    const handleConfirmar = async () => {
        const answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: [],
            option_selected_id: [],
            question_id: item._id,
            media: '',
            question_text: item.title,
            score: '0',
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: price,
            field_media: '',
            field_text: '',
            questionScore: item.questionScore,
            type: item.input_type.type,
            ponderar: item.questionScore && item.questionScore > 0, //[7, 8, 14, 18].includes(item.input_type.type),

            question: item.title,
            questionOptionSelected: [],
            questionOptionSelectedText: [],
            questionType: {
                title: item.input_type.title,
                type: item.input_type.type,
                id: item.input_type._id,
            },
            questionPrice: price,
            description: '',
            tag: '',
            questionImage: '',
            questionInput: price,
        }

        console.log(
            '✅3 DEBO CREAR ANSWER DE INPUT COMMENT => ',
            new Date().toDateString(),
        )

        await updateFormAnswerSchedule({
            newAnswer: answer,
            schedule_id,
            form_id,
            store_id,
        })
        await checkComplete(answer)
        // closeBottomSheet(true)
    }

    return (
        <View style={styles.containerFlex}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={styles.containerFlex}>
                <View style={styles.alignCenter}>
                    {/* {name_form && <Text style={[styles.title, { fontSize: 16, paddingBottom: 5 }]}>{name_form}</Text>} */}
                    {item.title && <Text style={styles.titleBis}>{item.title}</Text>}
                    {/*item.description && <Text style={styles.description}>{item.description}</Text>*/}
                </View>

                {item.media && showImage && (
                    <ImageWithZoomStores
                        uri={item.media ? item.media : placeholderGeneral}
                    />
                )}

                {/*<View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center',
                        paddingTop: 5,
                        paddingBottom: 8,
                    }}
                >
                    <TouchableOpacity
                        style={{
                            width: 34,
                            height: 34,
                            borderWidth: 2,
                            borderRadius: 17,
                            borderColor: theme.colors.colorApproved,
                            backgroundColor: theme.colors.colorApproved,
                            justifyContent: 'center',
                            marginRight: 12,
                        }}
                    >
                        <Feather name='check' size={18} color={'white'} style={{ alignSelf: 'center' }} />
                    </TouchableOpacity>

                    <View style={{ flexDirection: 'row', alignItems: 'center', paddingBottom: 0 }}>
                        <TouchableOpacity
                            onPress={() => newNa(!na)}
                            style={[
                                styles.containerMiniButton,
                                {
                                    width: 88,
                                    height: 34,
                                    borderRadius: 8,
                                    borderColor: theme.colors.darkGray,
                                    backgroundColor: na ? theme.colors.darkGray : 'transparent',
                                },
                            ]}
                        >
                            <Text style={{ fontSize: 14, fontWeight: 'bold', color: na ? 'white' : theme.colors.darkGray, marginHorizontal: 2 }}>
                                No aplica
                            </Text>
                        </TouchableOpacity>
                    </View>
                </View>*/}

                {/* {!na && ( */}
                <View style={styles.containerInput}>
                    <Text style={[styles.title, styles.paddinVertical]}>
                        Ingresar precio:
                    </Text>
                    <View style={styles.containerButton}>
                        <Text style={styles.text}>$</Text>
                        <TextInput
                            style={styles.input}
                            autoFocus={true}
                            placeholder='----'
                            placeholderTextColor={theme.colors.textSecondary}
                            value={price}
                            onChangeText={(text) => newPrice(text)}
                            keyboardType='number-pad'
                            inputMode='decimal'
                            onSubmitEditing={() => handleConfirmar()}
                        />
                    </View>
                </View>
                {/* )} */}

                <View style={styles.spacer}></View>

                <View style={styles.buttonContainer}>
                    <TouchableOpacity
                        style={styles.borderButton}
                        onPress={handleConfirmar}
                    >
                        <Text style={styles.borderButtonText}>
                            {languageFile.confirm}
                        </Text>
                    </TouchableOpacity>
                </View>
                <View style={styles.spacer}></View>
            </View>
        </View>
    )
}
